import React from "react";
import { useState,useEffect } from "react";
import { configData } from "../config";
import { useNavigate,useLocation ,useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Loading from './Loading';
import './classes/CreateCoupon.css';
import SalespersonSidebar from './SalespersonSidebar';


const CreateCoupon = () => {

    const navigate = useNavigate();
    const app_url = configData.APP_URL;
    const { id } = useParams(); 
    const location = useLocation();
    const loggedin_uid = localStorage.getItem('drupal_uid');

    const initialCouponForm = {
        coupon_code: "",
        status: "1",
    }

    const [isLoading, setIsLoading] = useState(true); 
    const [formData, setFormData] = useState(initialCouponForm);
    const[success,setSuccess] = useState('');
    const[error,setError] = useState({});

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData({ ...formData, [name]: value });
        
    };

    useEffect(() => {
        Promise.all([

        ])
        .then(() => {
        
            setIsLoading(false);
        })
        
    },[]);

    const handleSubmit = async (e) => {
        e.preventDefault(); // prevent page reload
        try {
            setIsLoading(true);
            const response = await fetch(app_url+'smwwcommercecoupon/putcoupondetails', {
            method: 'POST',
            body: JSON.stringify(formData),
            headers: {
                'Content-Type': 'application/json',
             },
            });
            const responsedata = await response.json();
            if(responsedata.data.msg === "Success") {
                setError('');
                setSuccess(responsedata.data.result);
                setFormData(initialCouponForm);
            }
             if(responsedata.data.msg === "Error") {
                setError(responsedata.data.result);
            }
         }  catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
        }
    };

    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (
                <div id="main">
                    {loggedin_uid && !Number.isNaN(loggedin_uid) ? (
                        <>
                            <Helmet><title>Create Coupon</title></Helmet>
                            <div className="left"></div>
                            <div className="center left-center">
                                <h1>Create Coupon</h1>
                                {error.length > 0 && (
          <div className="set-message-error" style={{ padding:"10px 10px 10px 50px",background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 10px no-repeat`}}>
           {error.map((item, index) => {
           return <>{item}<br /></>
          
        })}  
          </div>
        )}
                                {success && (
               
                       <>
                        <br/><div className="set-message-done">
                        <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span>{success}
                        </div></>
                  
                   
                        )}    
                                <div className="create-coupon-container">
                                    <form onSubmit={handleSubmit}>
                                        <label>Coupon Code <span className="form-required">*</span></label> 
                                        <input 
                                            style={{width:"30%"}} 
                                            autoComplete="off"
                                            type="text" 
                                            name="coupon_code" 
                                            id="coupon_code" 
                                            value={formData.coupon_code}
                                            onChange={handleChange}
                                            //required 
                                        />

                                        <label>Coupon Status <span className="form-required">*</span></label> 
                                        <select 
                                            id="status" 
                                            name="status"
                                            value={formData.status}
                                            onChange={handleChange}
                                        >
                                            <option value="1">Active</option>
                                            <option value="2">Disabled</option>
                                            <option value="3">Archive</option>
                                        </select> 

                                        <input 
                                            type="submit" 
                                            id="edit-submit" 
                                            name="" 
                                            value="Save coupon"
                                            style={{width:"155px", height: "30px"}} 
                                            className="form-submit" 
                                        />

                                    </form>
                                </div>
                            </div>
                            <div className="right">
                                <SalespersonSidebar />
                            </div>
                        </>
                    ) : (
                        <><p>You are not authorized</p></>   
                    )}
                </div>
            )}
        </>
    );
};
export default CreateCoupon;